import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { MobileProvider } from './MobileContext';
import { initNativeShell } from './nativeBridge';
import MobileLogin from './MobileLogin';
import MobileHome from './MobileHome';
import MobileMessages from './MobileMessages';
import MobileChat from './MobileChat';
import MobileContacts from './MobileContacts';
import MobileNews from './MobileNews';
import MobileDocuments from './MobileDocuments';
import MobileEvents from './MobileEvents';
import MobilePinboard from './MobilePinboard';
import MobileSettings from './MobileSettings';
import MobileTools from './MobileTools';
import MobileQuiz from './MobileQuiz';
import MobileMelody from './MobileMelody';
import MobileAttendance from './MobileAttendance';
import MobilePlusHours from './MobilePlusHours';
import MobileSlotRequests from './MobileSlotRequests';
import MobileMyLessons from './MobileMyLessons';
import MobileTerminplanung from './MobileTerminplanung';
import MobileOnlineJoin from './MobileOnlineJoin';
import MobileAppAccounts from './MobileAppAccounts';
import MobileInvoices from './MobileInvoices';
import MobileLogbook from './MobileLogbook';

function NativeShellBootstrap() {
  const navigate = useNavigate();
  useEffect(() => {
    initNativeShell((to) => {
      const path = String(to || '/');
      // Routes in MobileApp sind relativ zu /m/*
      const cleaned = path.replace(/^\/m\/?/, '/') || '/';
      navigate(cleaned === '/' ? '/' : cleaned);
    });
  }, [navigate]);
  return null;
}

export default function MobileApp() {
  return (
    <MobileProvider>
      <NativeShellBootstrap />
      <Routes>
        <Route path="login" element={<MobileLogin />} />
        <Route path="messages" element={<MobileMessages />} />
        <Route path="chat/:convId" element={<MobileChat />} />
        <Route path="contacts" element={<MobileContacts />} />
        <Route path="news" element={<MobileNews />} />
        <Route path="news/:newsId" element={<MobileNews />} />
        <Route path="documents" element={<MobileDocuments />} />
        <Route path="abrechnungen" element={<MobileInvoices />} />
        <Route path="files" element={<MobileDocuments area="personal" />} />
        <Route path="logbuch" element={<MobileLogbook />} />
        <Route path="events" element={<MobileEvents />} />
        <Route path="pinboard" element={<MobilePinboard />} />
        <Route path="attendance" element={<MobileAttendance />} />
        <Route path="unterricht" element={<MobileMyLessons />} />
        <Route path="terminplanung" element={<MobileTerminplanung />} />
        <Route path="plus-hours" element={<MobilePlusHours />} />
        <Route path="terminanfragen" element={<MobileSlotRequests />} />
        <Route path="online/:courseId" element={<MobileOnlineJoin />} />
        <Route path="tools" element={<MobileTools />} />
        <Route path="tools/quiz" element={<MobileQuiz />} />
        <Route path="tools/melody" element={<MobileMelody />} />
        <Route path="settings" element={<MobileSettings />} />
        <Route path="settings/identities" element={<MobileSettings initialSheet="identities" />} />
        <Route path="app-konten" element={<MobileAppAccounts />} />
        <Route index element={<MobileHome />} />
      </Routes>
    </MobileProvider>
  );
}
